import { z } from 'zod';

export const InheritanceRelationshipDataSchema = z.object({
  provisionNotes: z.string(),
});

export type IInheritanceRelationshipData = z.infer<
  typeof InheritanceRelationshipDataSchema
>;

export const getEmptyInheritanceRelationshipData = () => {
  return {
    provisionNotes: '',
  } as IInheritanceRelationshipData;
};
